import { render, staticRenderFns } from "./CataloguingLifecycleSelectInputWidget.vue?vue&type=template&id=0763d46a&scoped=true"
import script from "./CataloguingLifecycleSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./CataloguingLifecycleSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0763d46a",
  null
  
)

export default component.exports